import { render, staticRenderFns } from "./ReservationWidget.vue?vue&type=template&id=4b509460&"
import script from "./ReservationWidget.vue?vue&type=script&lang=js&"
export * from "./ReservationWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReservationWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports